module.exports = __webpack_public_path__ + "static/media/5DPO3.93e673c5.jpg";